/**
 * Created by mykurisu on 2017/11/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qr from 'qr-encode'
import {WKOwnDialog} from '../wk'
import shareFinish from '../../images/share_finish.png'


class DeepFocusDialog extends React.Component {

    constructor() {
        super();
        this.state = {
            qrcode: null
        }
    }

    componentDidMount() {
        if(!this.props.qcode) {
            axios.get('api/board/get_qrcode', {
                params: {
                    wtype: this.props.isResell ? 'share_pay' : 'share_free',
                    last_url: window.location.href
                }
            }).then(res => {
                    if (res.data.code === 0){
                        this.setState({
                            qrcode: res.data.data.qrcode_content
                        })
                    }
                })
        } else {
            this.setState({qrcode: this.props.qcode})
        }
    }

    render() {

        if (!this.props.details.showFocusDialog){
            return null
        }

        if (!this.state.qrcode){
            return null
        }
        window.MtaH5 && window.MtaH5.clickStat('deep_focus_show');
        window._czc && window._czc.push(["_trackEvent", 'common', 'click', 'deep_focus_show', 1])

        if(this.props.type === 'lecture_consult') {
            return (
                <div>
                    <WKOwnDialog show={true} buttons={[
                        {
                            label: <span style={{color: '#666'}}>关闭</span>,
                            onClick: () => {
                                this.props.dispatch({
                                    type: 'DEEP_FOCUS_DIALOG_HIDE'
                                });
                            }
                        }
                    ]}>
                        <p style={{width: '60px', height: '60px',borderRadius: '50%', margin: '0 auto 15px auto'}}>
                            <img src={shareFinish} alt=""/>
                        </p>
                        <p style={{fontSize: '16px', color: '#333'}}>提交成功</p>
                        <p className="content__qrcode">
                            <img src={qr(this.state.qrcode)} alt=""/>
                        </p>
                        <p>你的课程咨询已经提交给讲师 <br/>长按扫码关注，接收回复提醒</p>
                    </WKOwnDialog>
                </div>
            )
        }
        return (
            <div>
                <WKOwnDialog show={true} buttons={[
                    {
                        label: '关闭',
                        onClick: () => {
                            this.props.dispatch({
                                type: 'DEEP_FOCUS_DIALOG_HIDE'
                            });
                        }
                    }
                ]}>
                    <p style={{width: '60px', height: '60px',borderRadius: '50%', margin: '0 auto 15px auto'}}>
                        <img src={shareFinish} alt=""/>
                    </p>
                    <p style={{fontSize: '16px', color: '#333'}}>分享成功</p>
                    <p className="content__qrcode">
                        <img src={qr(this.state.qrcode)} alt=""/>
                    </p>
                    {this.props.isResell 
                        ? <p>长按扫码关注<br/>接收分销收益提醒</p>
                        : <p>长按扫码关注，听课赚钱两不误</p>
                    }
                </WKOwnDialog>
            </div>
        )
    }

}

export default connect(state => ({
    account: state.account,
    details: state.details,
}))(DeepFocusDialog)



// WEBPACK FOOTER //
// ./src/components/details/DeepFocusDialog.js